export default __webpack_public_path__ + "static/media/frutillas.358c14c9.jpg";